import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { WordDataTypeEnum, wordDataTypeDisplay } from 'src/modules/shared/models/enums/word-data-type.enum';
@Component({
  selector: 'hcr-robot-creation-word-input-datatypes',
  templateUrl: './robot-creation-word-input-datatypes.component.html',
  styleUrls: ['./robot-creation-word-input-datatypes.component.sass'],
})
export class RobotCreationWordInputDatatypesComponent implements OnChanges {
  @Input() acceptableDataTypes: WordDataTypeEnum;
  @Input() dataTypeConfigValue: number;
  @Output() dataTypeConfigValueChange: EventEmitter<number>;

  public dataTypes: {
    label: string;
    value: WordDataTypeEnum;
    checked: boolean;
  }[] = [];

  constructor() {
    this.dataTypeConfigValueChange = new EventEmitter<number>();
  }

  private _mountDetailedObject(): void {
    for (const key in WordDataTypeEnum) {
      if (typeof WordDataTypeEnum[key] === 'number' && this.acceptableDataTypes & +WordDataTypeEnum[key]) {
        this.dataTypes.push({
          label: wordDataTypeDisplay[key],
          value: +WordDataTypeEnum[key],
          checked: false,
        });
      }
    }
  }

  public dataTypeChanged(): void {
    const sumOfSelectedValues = this.dataTypes.reduce((acc, dt) => acc + (dt.checked ? dt.value : 0), 0);
    this.dataTypeConfigValueChange.emit(sumOfSelectedValues);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.acceptableDataTypes?.currentValue) {
      this._mountDetailedObject();
    }

    if (changes.dataTypeConfigValue?.currentValue || changes.acceptableDataTypes?.currentValue) {
      this.dataTypes.forEach((dt) => {
        dt.checked = Boolean(this.dataTypeConfigValue & dt.value);
      });
    }
  }
}
